import styled from "styled-components";

import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import { color, spacingDefaults } from "style/constants";

export const StyledMenu = styled(Menu)`
  && {
    .MuiMenu-paper {
      border: solid 1px ${color.BLUE};
    }
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  && {
    color: ${color.DARKGRAY};
    svg {
      margin-right: ${spacingDefaults.normal};
      path {
        stroke: ${color.DARKGRAY};
      }
    }
    &:hover {
      background-color: ${color.LIGHTBLUE};
      color: ${color.DARKBLUE};
      svg {
        path {
          stroke: ${color.DARKBLUE};
        }
      }
    }
  }
`;
